import type { Dispatch, SetStateAction } from "react";
import { Grid, Icon, Typography } from "@mui/material";

import RpSvgIcon from "@/components/icons/RpSvgIcon";
import LocationsExpandCollapseButtons from "@/features/campaigns/components/LocationsExpandCollapseButtons";
import { RpTab, RpTabs } from "@/components/muiCustom/tabs/JoinCampaignTab";

type JoinCampaignTitleHeaderProps = {
  campaign_name?: string;
  sub_title?: string;
  setSelectedTab: (_selectedTab: number) => void;
  selectedTab?: number;
  validLocationsCount?: number;
  inValidLocationsCount?: number;
  setExpanded: Dispatch<SetStateAction<string[]>>;
  expanded: string[];
  allLocationsIds?: string[];
};

function JoinCampaignTitleHeader({
  campaign_name,
  sub_title = "Make selections to customize advertising for each of your locations below",
  setSelectedTab,
  selectedTab = 0,
  validLocationsCount = 0,
  inValidLocationsCount = 0,
  setExpanded,
  expanded,
  allLocationsIds,
}: JoinCampaignTitleHeaderProps) {
  return (
    <Grid container spacing={2} className="mb-3" alignItems="center">
      <Grid size={{ md: "grow", xs: 12 }}>
        <Typography component="h2" variant="h6">
          <Icon
            component={RpSvgIcon}
            name="campaign"
            color="primary"
            className="mr-2"
          />
          {`${campaign_name} Campaign`}
        </Typography>
        <Typography variant="caption">{sub_title}</Typography>
      </Grid>
      <Grid size={{ md: "auto", xs: 12 }} sx={{ textAlign: "right" }}>
        <RpTabs
          value={selectedTab}
          onChange={(_event, newValue) => setSelectedTab(newValue as number)}
          variant="scrollable"
          scrollButtons={"off" as never}
        >
          <RpTab
            label={`Eligible Locations (${validLocationsCount})`}
            iconPosition="start"
            icon={
              <Icon fontSize="inherit" className="mr-1">
                dashboard
              </Icon>
            }
          />
          <RpTab
            label={`Not Eligible Locations (${inValidLocationsCount})`}
            iconPosition="start"
            icon={
              <Icon fontSize="inherit" className="mr-1">
                dashboard
              </Icon>
            }
          />
        </RpTabs>
      </Grid>
      <Grid size={{ md: "auto", xs: 12 }} sx={{ textAlign: "right" }}>
        <LocationsExpandCollapseButtons
          setExpanded={setExpanded}
          expanded={expanded}
          allLocationsIds={allLocationsIds}
          disabled={selectedTab === 1}
        />
      </Grid>
    </Grid>
  );
}

export default JoinCampaignTitleHeader;
